import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty } from '~/types/specialty';

/**
 * Configuration for Periodontal specialty referral form
 */
export const periodontalConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.PERIODONTAL,
  displayName: 'Periodontal',
  requiresToothSelection: true,
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [],
  dateFields: [
    {
      id: 'lastDentalCleaningDate',
      label: 'Date of Last Dental Cleaning',
      required: false,
    },
  ],
};
